import { EnvironmentRow, ProjectRow } from "namirasoft-infra"
import { NSRow } from "namirasoft-site-react"
import { useEffect, useState } from "react"
import { InfraRouterProps } from "../InfraRouterProps"
import { InfraCacheService } from "../InfraCacheService";

export interface ProjectDiagramTitleProps extends InfraRouterProps
{
    project_id: string;
    environment_id: string;
}

export interface ProjectDiagramTitleState
{
    environment?: EnvironmentRow,
    project?: ProjectRow,
}

function ProjectDiagramTitle(props: ProjectDiagramTitleProps)
{
    const [state, setState] = useState<ProjectDiagramTitleState>({});

    useEffect(() =>
    {
        load();
        // eslint-disable-next-line
    }, [props.project_id, props.environment_id]);

    const load = async () =>
    {
        let project_cache = InfraCacheService.getProject(props.project_id, props.servers.infra);
        let environment_cache = InfraCacheService.getEnvironment(props.environment_id, props.servers.infra);

        let project = await project_cache.get();
        let environment = await environment_cache.get();

        setState(prev => ({ ...prev, project, environment }));
    }

    return (
        <>
            {
                state.project && state.environment &&
                <NSRow classList={["align-items-center"]}>
                    <b className="d-flex align-items-center gap-2 text-dark" style={{lineHeight: "1.25rem"}}>
                        {state.project.name}<span style={{ marginBottom: "0.25rem", fontSize: "2rem" }}>&#8594;</span>{state.environment.name}
                    </b>
                </NSRow>
            }
        </>
    )
}

export default ProjectDiagramTitle;